import React from 'react';
import { useIntl } from 'react-intl';
import { elementType, oneOfType, string } from 'prop-types';

import WishlistButtonComponent from '../../components/WishlistButton/WishlistButton';
import { propTypes } from '../../util/types';

import { useWishlistButton } from './WishlistButton.hooks';

const WishlistButton = ({ listing, checkedTitle, uncheckedTitle, ...props }) => {
  const buttonProps = useWishlistButton({ listing });
  const intl = useIntl();
  const disabled = buttonProps.disabled || props.disabled;

  return (
    <WishlistButtonComponent
      {...props}
      {...buttonProps}
      disabled={disabled}
      checkedTitle={checkedTitle || intl.formatMessage({ id: 'WishlistButton.removeFromWishlist' })}
      uncheckedTitle={uncheckedTitle || intl.formatMessage({ id: 'WishlistButton.addToishlist' })}
    />
  );
};

WishlistButton.propTypes = {
  listing: oneOfType([propTypes.listing, propTypes.ownListing]),
  className: string,
  checkedTitle: string,
  uncheckedTitle: string,
  checkedComponent: elementType,
  uncheckedComponent: elementType,
};

export default WishlistButton;
